<template>
<div class="container">
    <div class="content-item-wrap content-top-wrap">
        <div class="user-info-wrap flex rcb">
            <div class="pic-wrap avatar-wrap">
                <img :src="dataSources.avatar || Images.img_avatar_default_pic" alt="" class="pic-img avatar-img" />
            </div>
            <div class="user-detail-wrap">
                <div class="user-name-wrap flex rcb">
                    <div class="title-wrap">
                        <span class="title">{{dataSources.name}}</span>
                        <span class="mobile">{{dataSources.mobile}}</span>
                    </div>
                    <div class="detail-wrap">
                        <span class="detail">加入时间：{{dataSources.team_member_time}}</span>
                    </div>
                </div>
                <div class="class-info-wrap flex rcs">
                    <div class="title">附加课程：</div>
                    <div class="detail flex rcs">
                        <div class="empty-tips" v-if="!dataSources.append_data || dataSources.append_data.length < 1">暂无附加课程</div>
                        <div class="class-item-wrap flex rcc" v-for="(item, index) in dataSources.append_data" :key="index">{{item}}</div>
                    </div>
                </div>
            </div>
        </div>

        <div class="class-level-wrap">
            <div class="title-wrap flex rcb">
                <div class="title">当前等级：{{dataSources.user_subject_name}}</div>
                <div class="detail">还差{{dataSources.lack}}升级{{dataSources.user_subject_next_name}}</div>
            </div>

            <div class="progress-wrap">
                <div class="progress-con" :style="showPercentage"></div>
            </div>

        </div>
    </div>

    <div class="content-item-wrap content-record-wrap">
        <van-tabs ref="tabs" color="#7181EB" title-active-color="#7181EB" v-model="active">

            <van-tab :title="item.title" v-for="(item, index) in navArray" :key="index">
                <student-record-tab :item="item" :type="item.type" :user_id="user_id" />
            </van-tab>

        </van-tabs>
    </div>
</div>
</template>

<script>
import StudentRecordTab from '../../components/student/StudentRecordTab';
export default {
    components: {
        StudentRecordTab
    },
    computed: {
        showPercentage() {
            return 'width: ' + (this.dataSources.percentage || 0) + '%;';
        }
    },
    data() {
        return {
            active: 0,
            user_id: this.$route.query.user_id || '',
            navArray: [{
                    title: '缴费记录',
                    type: this.Constants.RECORD_PAYMENT
                },
                {
                    title: '上课记录',
                    type: this.Constants.RECORD_CLASS
                },
                {
                    title: '商城消费记录',
                    type: this.Constants.RECORD_SHOP
                },
            ],
            dataSources: {},

        }
    },
    mounted() {
        this._requestDataSources();
    },
    methods: {

        async _requestDataSources() {
            let url = this.API.agent_student_detail;
            let data = {
                user_id: this.user_id,
            };
            const result = await this.$post(url, data);
            if (result.code === this.GLOBAL.SUCCESS_CODE) {
                this.dataSources = result.data;
            } else {
                this.ToastManager(result.msg);
            }
        },

    },
}
</script>

<style lang="less" scoped>
.container {

    .content-top-wrap {
        padding: 2rem 1.5rem;
        background-image: url('../../assets/img/img_bg_student.png');

        .user-info-wrap {
            margin-bottom: 2rem;

            .avatar-wrap {
                width: 6rem;
                height: 6rem;
                flex-shrink: 0;
                overflow: hidden;
                margin-right: 2rem;
                border-radius: 50%;

                .avatar-img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }
            }

            .user-detail-wrap {
                flex: 1;
                color: #fff;

                .user-name-wrap {

                    .title-wrap {

                        .title {
                            font-size: 1.6rem;
                        }

                        .mobile {
                            margin-left: 0.5rem;
                            word-break: break-all;
                        }
                    }

                    .detail-wrap {
                        flex-shrink: 0;
                        margin-left: 1rem;
                        .detail {
                            font-size: 1.2rem;
                        }
                    }
                }
            }
        }

        .class-info-wrap {
            margin-top: 1rem;
            font-size: 1.4rem;

            .title {

            }

            .detail {

                .class-item-wrap {
                    background: linear-gradient(45deg, #eba540, #ffbf62);
                    padding: .1rem 0.8rem;
                    border-radius: .1rem .5rem;
                }
            }
        }

    }

    .class-level-wrap {
        .title-wrap {
            .title {
                flex: 1;
                color: #fff;
                font-size: 1.3rem;
            }

            .detail {
                color: #fff;
                font-size: 1.2rem;
            }
        }

        .progress-wrap {
            width: 100%;
            height: .8rem;
            margin-top: .5rem;
            border-radius: .4rem;
            background: linear-gradient(270deg, rgba(255, 255, 255, 0.00), #ffffff);

            .progress-con {
                height: .8rem;
                background: #fff;
                border-radius: .4rem;
            }

        }

    }
}
</style>
